import type { z } from 'zod';

import { ProjectNeedsSchema } from './project-needs';

export const DSSuggestedIntakeSchema = ProjectNeedsSchema.pick({
  billingUnitsPerWeek: true,
  dsSuggestedId: true,
  estimatedDuration: true,
  generalSkills: true,
  industry: true,
  languageId: true,
  legalSkills: true,
  legalTechSkills: true,
  levelOfExperience: true,
  otherFocusAreas: true,
  primaryFocusArea: true,
  startDate: true,
  worksite: true,
}).required();

export type DSSuggestedIntake = z.infer<typeof DSSuggestedIntakeSchema>;
